import { Box, Dialog, Typography } from '@material-ui/core'
import React from 'react'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { Button } from '../button'
import { notifyDialogStyle } from './notify.style'

export const NotifyDialog = ({ title, hideTitle, okText, cancelText, onCancel, onOk, okProps, cancelProps, children, ...props }) => {
	const { t } = useTranslation()

	return (
		<Dialog {...props} css={notifyDialogStyle}>
			<Box margin={2}>
				{!hideTitle && (
					<Box className="header">
						<Typography variant="h6">{t(title)}</Typography>
					</Box>
				)}

				<Box marginTop={3} marginBottom={2} className="content-notify">
					{children}
				</Box>
				{/* A flex row with a gap, not a spacing Grid: the Grid's negative margins
				    pushed the buttons 8px past the content box on each side. */}
				<Box className="dialog-actions">
					{onCancel && (
						<Button variant="outlined" color="primary" onClick={onCancel} {...cancelProps}>
							{t(cancelText)}
						</Button>
					)}
					<Button key={okProps?.disabled} onClick={onOk} {...okProps}>
						{t(okText)}
					</Button>
				</Box>
			</Box>
		</Dialog>
	)
}

NotifyDialog.defaultProps = {
	open: true,
	okText: 'OK',
	cancelText: 'CANCEL',
	title: 'NOTIFICATION',
}
